import { Email } from './e-mail.model';
import { EdeliveryDocument } from './edelivery-document.model';

export class Account {
    accountNumber: string;
    edeliveryDocuments: EdeliveryDocument[];
    accountType: string;
    accountStatus: string;
    accountLinked: boolean;
    acctEmails: Email[];
    edelElgible: boolean;
    strCorrNum: string;
    strOfcNum: string;
    strRrNum: string;
    shortName: string;
    address: string;
    externalEmailAddr: string;
    ssn: string;
    subscriberEmails: Email[];
}
